import { applyBarrier, concurrency } from '@farfetched/core';
import { createInstance } from '@leprecoins/effector-query';
import { OverloadedParameters } from '@leprecoins/utility-types';
import { API_URL } from 'shared/config';
import { applyNotifications } from 'shared/lib';
import { authModel } from './auth-model';

const [createBaseAuthQuery, createBaseAuthMutation] = createInstance({
	url: API_URL,
	credentials: 'include',
	headers: authModel.$token.map((token) => ({ Authorization: `Bearer ${token}` })),
});

export const createAuthQuery: typeof createBaseAuthQuery = (
	params: OverloadedParameters<typeof createBaseAuthQuery>[0],
) => {
	const query = createBaseAuthQuery(params);

	concurrency(query, { strategy: 'TAKE_LATEST' });

	applyBarrier(query, { barrier: authModel.authBarrier });

	applyNotifications(query);

	return query;
};

export const createAuthMutation: typeof createBaseAuthMutation = (
	params: OverloadedParameters<typeof createBaseAuthMutation>[0],
) => {
	const mutation = createBaseAuthMutation(params);

	applyBarrier(mutation, { barrier: authModel.authBarrier });

	applyNotifications(mutation);

	return mutation;
};
